import { Typography } from "@mui/material"
import { SlotCardStyled, SlotCardTTStyled } from "./slot-card.styles"
import { SlotCardProps } from "./types"
import { useContext } from "react"
import { StepperDataContext } from "../../../context/stepper-context"
import { formatTimeSlot } from "../../../../../utils/common-utils"

const SlotCard: React.FC<SlotCardProps> = ({ slot }) => {
    const { selectedTimeSlot, setSelectedTimeSlot } = useContext(StepperDataContext)

    const handleClick = () => {
        setSelectedTimeSlot({
            start: slot.block.start,
            end: slot.block.end,
            prevTravel: slot.block.prevTravel
        })
    }

    const selected = selectedTimeSlot?.start === slot.block.start && selectedTimeSlot?.end === slot.block.end

    return (
        <>
          {(slot.block.prevTravel && slot.block.prevTravel !== 0) ? (
            <SlotCardTTStyled
              className={`${selected ? 'selected' : ''}`}
              onClick={handleClick}
            >
              <Typography className="date-range">
                {formatTimeSlot(slot.block.start, slot.block.end)}
              </Typography>
              <Typography variant="caption" className="travel-time">
                {`${slot.block.prevTravel} minutes away`}
              </Typography>
            </SlotCardTTStyled>
          ) : (
            <SlotCardStyled
              className={`${selected ? 'selected' : ''}`}
              onClick={handleClick}
            >
              <Typography className="date-range">
                {formatTimeSlot(slot.block.start, slot.block.end)}
              </Typography>
            </SlotCardStyled>
          )}
        </>
      )
}

export default SlotCard